import React from 'react';
import { connect } from 'react-redux';
import { setAuth, setAuthProperty, setPOSupplierType } from '../js/actions/index';

import axios from 'axios';

import { withRouter } from "react-router-dom";

import { Container, Col, Row, Tabs, Tab, Form, Button, Spinner, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Globe } from 'react-bootstrap-icons';

import { Formik } from 'formik';
import * as Yup from 'yup';

import LoadingComponent from '../components/LoadingComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';
import FooterComponent from '../components/FooterComponent';

import I18N from "../js/i18n";
import {i18n,getLocaleLabel} from "../js/global";

// Services
import {getSuppliersConfig} from '../services/Supplier';
import {getBusinessConfig} from '../services/Business';
import {geti18nLabels, geti18nBusiness, geti18nBusinessSuppliers} from "../services/i18n";

import {
    setI18N
  } from "../js/actions/index";

import {
    EXTERNAL, ZH_HK, I18N_LOCALES, UI, BUSINESSES, SUPPLIERS, UAT
} from "../constants/GlobalConstant";

const https = require("https");

var md5 = require('md5');
/*
const schemaRestuarant = Yup.object({
  merchantId: Yup.string().required(),
  loginId: Yup.string().required(),
  password: Yup.string().required()
});
*/
function mapDispatchToProps(dispatch) {
    return {
      setAuth: auth => dispatch(setAuth(auth)),
      setAuthProperty: payload => dispatch(setAuthProperty(payload)),
      setI18N: payload => dispatch(setI18N(payload)),
      setPOSupplierType: payload => dispatch(setPOSupplierType(payload))
    };
}

let validationSchemaRestuarant = null;
let schemaSupplier = null;
let validationSchemaSupplier  = null;

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            doAPI:false,
            authFail:false,
            serverError:false,
            serverErrorLabel:null,
            mode:'',
            i18n:{}
        };
    }

    componentDidMount = async () => {
        setTimeout(
            () => {
                if(!this.props.mode) {
                    this.setState({
                        mode:"restuarant"
                    })
                }
        },250);

        this.props.setAuthProperty({
            "prop":"mode",
            "value":this.props.mode
        });

        // i18n
        try {
            // I18N temporary env condition
            if(process.env.REACT_APP_ENV !== UAT) {
                const props = {
                    token: null
                };

                const i18nLabels = await this.getI18NLabels(props);
        
                this.props.setI18N({
                    "property":UI,
                    "value":i18nLabels.data.data
                });
            }

                this.seti18n();

            // Validation
            validationSchemaRestuarant = Yup.object().shape({
                merchantId: Yup.string()
                .required(<I18N type="ui" path="MERCHANT_ID_IS_REQUIRED" def="*Merchant ID is required"/>),
                loginId: Yup.string()
                .required(<I18N type="ui" path="USERNAME_IS_REQUIRED" def="*Username is required"/>),
                password: Yup.string()
                .required(<I18N type="ui" path="PASSWORD_IS_REQUIRED" def="*Password is required"/>)
            });
            
            schemaSupplier = Yup.object({
                loginId: Yup.string().required(),
                password: Yup.string().required()
            });
            
            validationSchemaSupplier = Yup.object().shape({
                loginId: Yup.string()
                .required(<I18N type="ui" path="USERNAME_IS_REQUIRED" def="*Username is required"/>),
                password: Yup.string()
                .required(<I18N type="ui" path="PASSWORD_IS_REQUIRED" def="*Password is required"/>)
            });

          } catch (err) {
            this.handleErrorAPI(err);
          }
    }

    componentDidUpdate() {
        if(this.props.mode && (this.state.mode !== this.props.mode)) {
            this.setState({
                mode:this.props.mode
            });
        }
    }

/************************
  
API CALLS

************************/

    handleErrorAPI = (err) => {
        console.error(err);
        this.setState({
            isLoading:false,
            serverError:true,
            serverErrorLabel:"Internal Server Error (400)",
            doAPI:false,
        });
    }

// (GET) i18n Labels

getI18NLabels = () => {
    try {
      const props = {
        token: this.props.auth.token
      };
      return geti18nLabels(props);
    } catch (err) {
      this.handleErrorAPI(err);
    }    
}

// (GET) i18n Business

getI18NBusiness = (businessId) => {
    try {
      const props = {
        token: this.props.auth.token,
        businessId: businessId
      };
      return geti18nBusiness(props);
    } catch (err) {
      this.handleErrorAPI(err);
    }    
}

// (GET) i18n Business Suppliers

getI18NBusinessSuppliers = (businessId) => {
    try {
      const props = {
        token: this.props.auth.token,
        businessId: businessId
      };
      return geti18nBusinessSuppliers(props);
    } catch (err) {
      this.handleErrorAPI(err);
    }    
}

/*
(POST) Handle Submit Restuarant
*/

    handleSubmitRestuarant = (values) => {
        let that = this;
        this.setState({
            isLoading:true
        }, () => {
            let url = `${process.env.REACT_APP_API_URL}/api/getUserIdentity/restuarant`;
            let account = values.merchantId;
            let user = values.loginId;
            let pwd = md5(values.password);
                   
            axios({
                method: 'get',
                url: url,
                params: {
                  account:account,
                  user:user,
                  pwd:pwd
                }
            }).then((result) => {
                let response = result.data;
                if( !response.data ) {
                    that.setState({
                        authFail:true,
                        doAPI:false
                    });
                } else {

                    (async () => {

                        // Business Configuration

                        let businessConfig = await this.getBusinessConfig(response.token);
                        let poApproval = false;
                        let consolidation = false;
                        let autoReceipt = false;
                        let isInternalSupplier = false;
                        let logisticsTable = false;
                        let ui = {};
                        let intervals = [];
                        let units = {
                            "weighing":[]
                        };
                        let erp = {};
                        let isReceipt = false;

                        if(!businessConfig) {
                            this.setState({
                                serverError:true
                            });
                            return;
                        }

                        let poApprovalData = businessConfig.data.data.flows.poApproval;
                        let receiptData = businessConfig.data.data.flows.receipt;
                        let restaurantsData = businessConfig.data.data.restaurants;
                        
                        // PO Approval
                        if(poApprovalData && poApprovalData.length) {
                            let config = poApprovalData.filter( (obj) => obj.businessId === response.data.BusinessId)[0];
        
                            if(typeof config !== "undefined") {
                                // this business id has approval module
                                poApproval = true;
                                if(typeof config.config.consolidation !== "undefined") {
                                    consolidation = config.config.consolidation;
                                }
                                if(typeof config.config.autoReceipt !== "undefined") {
                                    autoReceipt = config.config.autoReceipt;
                                }
                                if(typeof config.config.internalSupplier !== "undefined") {
                                    isInternalSupplier = config.config.internalSupplier;
                                }
                                if(typeof config.ui !== "undefined") {
                                    ui = config.ui;
                                }
                                if(config.intervals.length > 0) {
                                    intervals = config.intervals;
                                }
                                if(typeof config.units !== "undefined") {
                                    units = config.units;
                                }
                            }
                        }

                        // receipt
                        if(receiptData && receiptData.length) {
                            let filter = receiptData.filter( (obj) => obj.businessId === response.data.BusinessId)[0];
                            if(filter) {
                                isReceipt = true;
                            }
                        }

                        // Restaurants
                        if(restaurantsData && restaurantsData.length) {
                            let filter = restaurantsData.filter( (obj) => obj.businessId === response.data.BusinessId)[0];
                            if(filter) {
                                if(filter.erp) {
                                    erp = filter.erp;
                                }
                                if(filter.ui && Object.keys(ui).length === 0) {
                                    ui = filter.ui;
                                }
                            }
                        }

                        if(Object.keys(ui).length === 0) {
                            this.setState({
                                doAPI:false,
                                serverError:true
                            });
                            return;
                        }

                        // Supplier Configuration
                        (async () => {
                            let suppliersConfig = await this.getSuppliersConfig(response.token);

                            that.props.setAuth({
                                'mode':'restuarant',
                                'isLogin':true,
                                'token':response.token,
                                'businessId':response.data.BusinessId,
                                'businessName':response.data.BusinessName,
                                'operatorId':response.data.OperatorId,
                                'operatorName':response.data.OperatorName,
                                'isSupplier':false,
                                'supplierId':0,
                                'supplierName':'',
                                'role':'admin',
                                'supplierNum':'',
                                'poApproval':poApproval,
                                'consolidation':consolidation,
                                'autoReceipt':autoReceipt,
                                'isInternalSupplier':isInternalSupplier,
                                'logisticsTable':logisticsTable,
                                'suppliersConfig':suppliersConfig.data.data.suppliers,
                                'ui':ui,
                                'intervals':intervals,
                                'units':units,
                                'erp':erp,
                                'isReceipt':isReceipt,
                                'locale':this.props.auth.locale 
                                    ? 
                                        this.props.auth.locale
                                        : 
                                            response.data.locale 
                                            ? 
                                            this.props.auth.locale
                                            : 
                                            ZH_HK 
                            }).then( () => {
                                (async() => {
                                    try {
                                        // I18N temporary env condition
                                        if(process.env.REACT_APP_ENV !== UAT) {

                                            // Business
                                            const i18nBusiness = await this.getI18NBusiness(response.data.BusinessId);
                                            let businessData = {};
                                                                                
                                            if(!Object.keys(i18nBusiness.data.data).length) {
                                                I18N_LOCALES.forEach( (locales) => {
                                                    let locale = locales.locale;
                                                    if(locale !== ZH_HK) {
                                                        let obj = {};
                                                        obj[BUSINESSES] = [];
                                                        businessData[locale] = obj; 
                                                    }
                                                });
                                            } else {
                                                businessData = i18nBusiness.data.data;
                                            }

                                            this.props.setI18N({
                                                "property":BUSINESSES,
                                                "value":businessData
                                            });

                                            let suppliersData = {};
                                            const i18nSuppliers = await this.getI18NBusinessSuppliers(response.data.BusinessId);

                                            if(!Object.keys(i18nSuppliers.data.data).length) {
                                                I18N_LOCALES.forEach( (locales) => {
                                                    let locale = locales.locale;
                                                    if(locale !== ZH_HK) {
                                                        let obj = {};
                                                        obj[SUPPLIERS] = [];
                                                        suppliersData[locale] = obj; 
                                                    }
                                                });
                                            } else {
                                                suppliersData = i18nSuppliers.data.data;
                                            }

                                            this.props.setI18N({
                                                "property":SUPPLIERS,
                                                "value":suppliersData
                                            });

                                        }
                                        
                                        if(window.location.pathname.indexOf('login') === -1 && window.location.pathname !== '/') {
                                            that.props.history.push(window.location.pathname);
                                        } else {
                                            if(poApproval) {
                                                that.props.history.push(`/purchase-orders/pending-approval`);
                                            } else {
                                                that.props.history.push(`/home`);
                                            }
                                        }
                                    } catch (err) {
                                        this.handleErrorAPI(err);
                                    }
                                })();
                            });

                        })();

                    })();
                }
            }).catch( (err) => {
                this.handleErrorAPI(err);           
            });
        });
    }

/*
(POST) Handle Submit Supplier
*/

    handleSubmitSupplier = (values) => {
        //let that = this;

        this.setState({
            doAPI:true
        }, () => {
            let url = `${process.env.REACT_APP_API_URL}/api/getUserIdentity/supplier`;
            let user = values.loginId;
            let pwd = md5(values.password);
            
            axios({
                method: 'get',
                url: url,
                params: {
                  user:user,
                  pwd:pwd
                },
                httpsAgent: new https.Agent({  
                    rejectUnauthorized: false
                })
            }).then((result) => {
                let response = result.data;
                
                if( !response.data ) {
                    this.setState({
                        authFail:true,
                        doAPI:false
                    });
                } else {

                    (async () => {
                        let res = await this.getSuppliersConfig(response.token);
                        let supplierConfig = null;
                        let poApproval = false;
                        let consolidation = false;
                        let autoReceipt = false;
                        let isInternalSupplier = false;
                        let logisticsTable = false;
                        let ui = {};
                        let intervals = [];
                        let units = {
                            "weighing":[]
                        };
                        let erp = {};

                        if(!res) {
                            this.setState({
                                serverError:true
                            });
                            return;
                        }

                        let poApprovalData = res.data.data.poApproval;
                        let suppliersData = res.data.data.suppliers;
                        let branchProductMapping = false;
                       
                        if(typeof poApprovalData !== "undefined") {
                            let config = poApprovalData.filter( (obj) => obj.supplierId === response.data.SupplierId)[0];

                            if(typeof config !== "undefined") {
                                // this supplier id has approval module
                                poApproval = true;
                                if(typeof config.config.consolidation !== "undefined") {
                                    consolidation = config.config.consolidation;
                                }
                                if(typeof config.config.autoReceipt !== "undefined") {
                                    autoReceipt = config.config.autoReceipt;
                                }
                                if(typeof config.config.internalSupplier !== "undefined") {
                                    isInternalSupplier = config.config.internalSupplier;
                                }
                                if(typeof config.config.logisticsTable !== "undefined") {
                                    logisticsTable = config.config.logisticsTable;
                                }
                                if(typeof config.ui !== "undefined") {
                                    ui = config.ui;
                                }
                                if(config.intervals.length > 0) {
                                    intervals = config.intervals;
                                }
                                if(typeof config.units !== "undefined") {
                                    units = config.units;
                                }
                            }
                        }

                        if(suppliersData && suppliersData.length) {
                            
                            let filter = suppliersData.filter( (obj) => obj.supplierId === response.data.SupplierId)[0];

                            if(filter) {
                                supplierConfig = filter;

                                if(filter.ui && Object.keys(ui).length === 0) {
                                    ui = filter.ui;
                                }

                                if(filter.erp) {
                                   erp = filter.erp; 
                                }

                                if(response.data.erpSessionId) {
                                    erp.sessionId = response.data.erpSessionId;
                                }

                                if(filter.branchProductMapping) {
                                    branchProductMapping = true;
                                }
                            }
                        }

                        if(Object.keys(ui).length === 0) {
                            this.setState({
                                doAPI:false,
                                serverError:true
                            });
                            return;
                        }

                        this.props.setAuth({
                            'mode':'supplier',
                            'isLogin':true,
                            'token':response.token,
                            'businessId':0,
                            'businessName':'',
                            'operatorId':response.data.OperatorId,
                            'operatorName':response.data.OperatorName,
                            'isSupplier':true,
                            'supplierId':response.data.SupplierId,
                            'supplierName':response.data.SupplierName,
                            'supplierNum':response.data.SupplierNum,
                            'role':response.data.role,
                            'suppliersConfig':supplierConfig,
                            'poApproval':poApproval,
                            'consolidation':consolidation,
                            'autoReceipt':autoReceipt,
                            'isInternalSupplier':isInternalSupplier,
                            'logisticsTable':logisticsTable,
                            'ui':ui,
                            'units':units,
                            'erp':erp,
                            'branchProductMapping':branchProductMapping,
                            'isReceipt':false
                        }).then( () => {
                            this.props.setPOSupplierType(EXTERNAL);
                            
                            if(window.location.pathname.indexOf('login') === -1 && window.location.pathname !== '/') {
                                this.props.history.push(window.location.pathname);
                            } else {
                                this.props.history.push('/home');
                            }
                        });
                    })();
                }
            }).catch( (err) => {
                this.handleErrorAPI(err);
            });
        });


    }

/*
(GET) Business Config
*/

    getBusinessConfig = async (token) => {
        try {
            const props = {
                token:token,
                env:process.env.REACT_APP_ENV
            }
            const response = await getBusinessConfig(props);
            return response;
        } catch (err) {
            this.handleErrorAPI(err);
        }
    }

/*
(GET) Suppliers Config
*/

    getSuppliersConfig = async (token) => {
        try {
            const props = {
                token:token,
                env:process.env.REACT_APP_ENV
            }
            const response = await getSuppliersConfig(props);
            return response;
        } catch (err) {
            this.handleErrorAPI(err);
        }
    }

/*
Login Form
*/

    handleSelectTab = (eventKey) => {
        this.setState({
            mode:eventKey,
            errorAPI:false
        })
    }

    /*
    getModeHeader = () => {
        if(this.props.mode === "restuarant") {
            return "Restuarant";
        } else if(this.props.mode === "supplier") {
            return "Supplier";
        }
    }
    */

// set i18n (local)
    seti18n = () => {
        [{
            type:'ui',
            path:'ENTER_YOUR_MERCHANT_ID',
            def:'Enter your Merchant ID'
        },{
            type:'ui',
            path:'ENTER_YOUR_USERNAME',
            def:'Enter your Username'
        },{
            type:'ui',
            path:'ENTER_YOUR_PASSWORD',
            def:'Enter your Password'
        }].forEach( (obj) => {
            i18n(obj.type,obj.path,obj.def).then((value) => {
                let i18n = JSON.parse(JSON.stringify(this.state.i18n));
                
                if(value) {
                    i18n[obj.path] = value;
                } else {
                    i18n[obj.path] = obj.def;
                }                
                
                this.setState({
                    i18n:i18n
                });
            });    
        });
    }

    handleSelectLocale = (value) => {
        this.props.setAuthProperty({
            "prop":"locale",
            "value":value
        }).then( () => {
            this.seti18n();
        });
    }

    render() {
        return (
            <>
            <Container fluid className="p-0 m-0">

                <Navbar collapseOnSelect className="navbar" expand="lg" bg="primary-light">
                    <Navbar.Brand href="/home"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="240.23 183.43 69.54 96.31" width="25" height="25" fill="#28b46e" style={{verticalAlign: "top"}}><path d="m 267.16 279.743 l -17.419 0 l 0 -22.679 c 4.169 -4.645 9.975 -8.099 17.419 -10.362 l 0 33.041 z m 42.61 -65.914 c 0 9.231 -2.531 15.93 -7.593 20.099 l 0 45.815 l -17.509 0 l 0 -39.205 l -5.806 1.072 l -5.985 1.072 c -4.645 1.013 -8.575 2.174 -11.791 3.484 c -8.754 3.633 -15.126 9.737 -19.116 18.312 c -3.871 -15.245 -1.281 -25.667 7.771 -31.265 l 0 -20.853 c 0 -13.101 1.876 -16.213 5.628 -21.334 c 3.752 -5.062 10.421 -7.593 20.009 -7.593 c 9.886 0 16.824 2.471 20.814 7.414 c 3.99 4.943 5.985 8.114 5.985 21.513 l 0 3.434 c -4.347 2.204 -10.184 4.11 -17.509 5.717 l 0 -10.456 c 0 -7.086 -0.625 -7.91 -1.875 -10.471 c -1.489 -2.322 -3.752 -3.484 -6.789 -3.484 c -3.335 0 -5.628 1.191 -6.879 3.573 c -1.31 2.382 -1.965 3.176 -1.965 10.382 l 0 16.173 l 5.538 -0.982 l 5.539 -0.983 c 4.645 -0.834 8.426 -1.637 11.345 -2.412 c 8.635 -2.144 15.364 -5.151 20.188 -9.022 z"></path></svg><I18N type="ui" path="AGORA_HUB" def="AGORA HUB"/></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                    </Nav>
                    {/* I18N temporary env condition */}
                    {process.env.REACT_APP_ENV !== UAT &&    
                    <NavDropdown 
                    title={<span><Globe size={16} className="mb-1 mr-1" /> {getLocaleLabel(this.props.auth.locale)}</span>} 
                    id="language-nav-dropdown"
                    >
                        {I18N_LOCALES.map( (obj) => {return (<NavDropdown.Item onClick={ () => this.handleSelectLocale(`${obj.locale}`) }>{obj.label}</NavDropdown.Item>)
                        })}
                    </NavDropdown>
                    }

                    </Navbar.Collapse>
                </Navbar>
                    <Container className="vh-100 container">
                <Row className="align-items-center h-100">
                    <Col xs={12}>
                    
                    <div className="text-center">
                        <img src="/assets/images/logo_horus.png" width="auto" height="200px" alt="Horus" />
                    </div>

                    {!this.state.mode
                    ?
                        <LoadingComponent />
                    :
                        <Tabs defaultActiveKey={this.state.mode} id="login-tab" className="mt-4">
                            <Tab eventKey="restuarant" title={<I18N type="ui" path="RESTAURANT" def="Restaurant"/>}>
                            <Formik 
                            validationSchema={validationSchemaRestuarant}
                            initialValues={{ merchantId:"", loginId:"", password:"" }}
                            onSubmit={ (values) => this.handleSubmitRestuarant(values)}
                        >
                            {( {values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting }) => (  
                                <div className="mt-4">
                                {this.state.authFail &&
                                    <AlertErrorComponent
                                        label={<I18N type="ui" path="INCORRECT_LOGIN_CREDENTIALS" def="Incorrect login credentials"/>}
                                    />
                                }
                                {
                                    this.state.serverError &&
                                    <ServerErrorComponent 
                                        label={this.state.serverErrorLabel}
                                    />                          
                                }
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group controlId="formMerchantId">
                                        <Form.Label><I18N type="ui" path="MERCHANT_ID" def="Merchant ID"/></Form.Label>
                                        <Form.Control 
                                            type="textbox" 
                                            name="merchantId" 
                                            placeholder={this.state.i18n["ENTER_YOUR_MERCHANT_ID"]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.merchantId} 
                                            isInvalid={touched.merchantId && errors.merchantId}
                                            className={touched.merchantId && errors.merchantId ? "error" : null} 
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.merchantId}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mt-3" controlId="formLoginId">
                                        <Form.Label><I18N type="ui" path="USERNAME" def="Username"/></Form.Label>
                                        <Form.Control 
                                            type="textbox" 
                                            name="loginId" 
                                            placeholder={this.state.i18n["ENTER_YOUR_USERNAME"]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.loginId}
                                            isInvalid={touched.loginId && errors.loginId}
                                            className={touched.loginId && errors.loginId ? "error" : null} 
                                            />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.loginId}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mt-3" controlId="formBasicPassword">
                                        <Form.Label><I18N type="ui" path="PASSWORD" def="Password"/></Form.Label>
                                        <Form.Control 
                                            type="password"
                                            name="password"
                                            placeholder={this.state.i18n["ENTER_YOUR_PASSWORD"]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                            isInvalid={touched.password && errors.password} 
                                            className={touched.password && errors.password ? "error" : null} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.password}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className="mt-4" disabled={this.state.doAPI}>
                                        {this.state.doAPI &&
                                        <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                        />
                                        }
                                        <I18N type="ui" path="LOGIN" def="Login"/>
                                    </Button>

                                </Form>
                                </div>
                                )}
                                </Formik>                                
                            </Tab>
                            
                            <Tab eventKey="supplier" title={<I18N type="ui" path="SUPPLIER" def="Supplier"/>}>
                            <Formik 
                            validationSchema={validationSchemaSupplier}
                            initialValues={{ loginId:"", password:"" }}
                            onSubmit={ (values) => this.handleSubmitSupplier(values)}
                            >
                            {( {values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting }) => (  
                                <div className="mt-4">
                                {this.state.authFail &&
                                    <AlertErrorComponent
                                        label={<I18N type="ui" path="INCORRECT_LOGIN_CREDENTIALS" def="Incorrect login credentials"/>}
                                    />
                                }
                                {
                                    this.state.serverError &&
                                    <ServerErrorComponent 
                                        label={this.state.serverErrorLabel}
                                    />                          
                                }
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group controlId="formLoginIdSupplier">
                                        <Form.Label><I18N type="ui" path="USERNAME" def="Username"/></Form.Label>
                                        <Form.Control 
                                            type="textbox" 
                                            name="loginId" 
                                            placeholder={this.state.i18n["ENTER_YOUR_USERNAME"]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.loginId}
                                            isInvalid={touched.loginId && errors.loginId}
                                            className={touched.loginId && errors.loginId ? "error" : null} 
                                            />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.loginId}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mt-3" controlId="formBasicPasswordSupplier">
                                        <Form.Label><I18N type="ui" path="PASSWORD" def="Password"/></Form.Label>
                                        <Form.Control 
                                            type="password"
                                            name="password"
                                            placeholder={this.state.i18n["ENTER_YOUR_PASSWORD"]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                            isInvalid={touched.password && errors.password} 
                                            className={touched.password && errors.password ? "error" : null} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.password}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className="mt-4" disabled={this.state.doAPI}>
                                        {this.state.doAPI && !this.state.serverError && 
                                        <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                        />
                                        }
                                        <I18N type="ui" path="LOGIN" def="Login"/>
                                    </Button>

                                </Form>
                                </div>
                                )}
                                </Formik>                          
                            </Tab>
                        </Tabs>
                    }
               
                    </Col>
                </Row>
                </Container>
            </Container>
            <FooterComponent />
            </> 
        )
    }
}

const mapStateToProps = state => {
    const {auth, i18n} = state;
    return { auth: auth, i18n: i18n };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));